import React, { useState, useEffect } from "react";
import Radio from "@material-ui/core/Radio";
import { Accordion, Card } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import {
  ContainerType,
  ItemCard,
  TextCard,
  ItemDropDown,
  SelectBranches,
} from "./styles";
import { CardHeader } from "~/pages/Order/styles";
import "~/components/styles/Global.css";
import mapa from "~/assets/images/mapa.svg";
import { analytics, logEvent }  from "~/services/firebaseConfig";
import Datepicker from "~/components/layout/DatepickerField";

export default function OrderTypeEdit(props) {
  const [branch, setBranch] = useState(
    props.filiais[0] ? props.filiais[0] : ""
  );
  const [orderNormal, setOrderNormal] = useState(false);
  const [orderTake, setOrderTake] = useState(false);
  const [showDatepicker, setShowDatepicker] = useState(false);
  const [activeKey, setActiveKey] = useState("1")

  const selectedBranch = useSelector(
    (state) => state.orderReducer.selectedBranch
    );
    const items = useSelector((state) => state.orderReducer.items);
    const orderReducer = useSelector((state) => state.orderReducer);
    const errorOrder = useSelector((state) => state.orderReducer.errorOrder);
  const dispatch = useDispatch();

  function editOrder(typeOrder) {
    dispatch({
      type: "EDIT_SUMMARY",
      typeOrder,
      branch: branch,
    });
  }

  function selectBranch(branchIndex) {
    localStorage.setItem("supplyBranchId", props.filiais[branchIndex].id);
    dispatch({
      type: "SELECT_BRANCH",
      selectedBranch: branchIndex,
    });
  }

  useEffect(() => {
    props.filiais.map((branch, index) => {
      if (branch.id === localStorage.getItem("supplyBranchId")) {
        selectBranch(index);
      }
    });
    if(orderReducer.orderTake) {
      setOrderTake(true);
    }
  }, []);


  useEffect(()=>{
    if(errorOrder) {
      setActiveKey('2')
    }
  },[])

  return (
    <ContainerType>
      <Accordion activeKey={activeKey} onSelect={key => setActiveKey(key)}>
        <Card.Header style={CardHeader}>Tipo de pedido</Card.Header>
        <Card>
          {localStorage.getItem("standardServiceType") === "RETIRA" ? (
            <>
              <Accordion.Toggle as={Card} eventKey="2">
                <ItemCard
                  onClick={() => {
                    setOrderTake(true);
                    if (orderNormal) {
                      setOrderNormal(false);
                    }
                    editOrder("Retira");
                    dispatch({ type: "SET_ORDER_TAKE", orderTake: true });
                  }}
                >
                  <img src={mapa} alt="Ícone de retirada de pedido" />
                  <TextCard>Retira</TextCard>
                  <Radio color="primary" checked={orderTake} />
                </ItemCard>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="2">
                <div style={{ height: showDatepicker ? 585 : "auto" }}>
                  <ItemDropDown>
                    <TextCard padding={`1rem 1rem .3rem 1rem`}>
                      Selecione Filial Abastecedora
                    </TextCard>
                    <SelectBranches
                      margin={"0rem .75rem 1.3rem .7rem"}
                      onChange={(event) => {
                        props.filiais.map((branch, index) => {
                          if (branch.name === event.target.value) {
                            selectBranch(index);
                            logEvent(analytics, 'troca_filial');
                          }
                        });
                      }}
                      disabled={items.length > 0}
                    >
                      {props.filiais.map((element, index) => (
                        <option
                          element={element}
                          key={element.id}
                          selected={selectedBranch === index}
                        >
                          {element.name}
                        </option>
                      ))}
                    </SelectBranches>
                  </ItemDropDown>
                  <ItemDropDown>
                    <TextCard padding={`1rem 1rem .3rem 1rem`}>
                      Data de Carregamento
                    </TextCard>
                    <Datepicker setShowDatepicker={setShowDatepicker} />
                  </ItemDropDown>
                </div>
              </Accordion.Collapse>
            </>
          ) : (
            <>
              <Accordion.Toggle as={Card} eventKey="2">
                <ItemCard
                  onClick={() => {
                    setOrderTake(true);
                    if (orderNormal) {
                      setOrderNormal(false);
                    }
                    editOrder("Entrega");
                    dispatch({ type: "SET_ORDER_TAKE", orderTake: true });
                  }}
                >
                  <img src={mapa} alt="Ícone de entrega de pedido" />
                  <TextCard>Entrega</TextCard>
                  <Radio color="primary" checked={orderTake} />
                </ItemCard>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="2">
                <div style={{ height: showDatepicker ? 585 : "auto" }}>
                  <ItemDropDown>
                    <TextCard padding={`1rem 1rem .3rem 1rem`}>
                      Data de Carregamento
                    </TextCard>
                    <Datepicker setShowDatepicker={setShowDatepicker} />
                  </ItemDropDown>
                </div>
              </Accordion.Collapse>
            </>
          )}
        </Card>
      </Accordion>
    </ContainerType>
  );
}
